import {generatePath, handleRedirect} from "../../../../config/redirectWindow";

export default {
    data() {
        return{
            modalShow:false,
        }
    },
    components: {
        TheCreate: () => import("@/components/ProductComponents/TheCreate")   //使用webpack 的异步 import，避免循环调用错误
    },
    props: {
        dialogCount: {
            type: Number,
            default: 0
        },
		id: String, //元素id
        _style: Object, //元素主体 style
        settings: Object,  //这些在ComsJosn
		realtimeData: Object, //实时参数
        wrapperStyle: Object, //编辑框
        dynamicProps: Object,     //

		editType: Number,        //0-未保存1-已保存2-已发布可读3-已发布可交互
		mode: String,             //由isEditMode生成mode
		productSaveForm: Object, //保存页面信息的一个对象
		companyId: Number,   //页面所属公司id
        preProductId:Number,//跳转至创作模块页面的来源
		fromType: Number,    //跳转至创作模块页面的来源
        name: String,    // 组件的名称
    },
    computed: {
        style() {
            let style = {
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                right: 0,
                ...this._style,
            }
            return style
        },
        modelStyle(){
            let height = this.realtimeData.modalHeight;
            if(!height || height<=0){
                height = 600;
            }
            return `display: flex;overflow-y: scroll;overflow-x: scroll;height:${height/2}px;`;
            //return 'display: flex;overflow-y: scroll;height:' + this.realtimeData.modalHeight + ';px';

        },
    },
    methods: {
        async handleClick(e) {
            //console.log("矩形点击了")
            console.log("kankanxianzaide",this.productSaveForm)
            this.$emit("click",e);
            this.$emit("fun");
            if(this.mode==='view'){
                //console.log("预览模式下点击",this.settings.flag,this.realtimeData.selectValue1)
                if(this.settings.flag === true){
                    if(this.realtimeData.selectValue1 == 1)
                    {
                        this.productId=this.realtimeData.pageId;
                        let url = await generatePath(this.productId,this.companyId,this.preProductId);
                        handleRedirect(url);
                    }
                    if(this.realtimeData.selectValue1 == 0){
                        console.log("展示模态窗")
                        this.modalShow = true;
                    }
                }
            }
        },
    },
    watch: {
        'realtimeData.top': {  // x绑定
            handler() {
                this.wrapperStyle.top = this.realtimeData.top +'px'
            }
        },
        'realtimeData.left': {  // y绑定
            handler() {
                this.wrapperStyle.left = this.realtimeData.left +'px'
            }
        },
        'realtimeData.height': {  // 高度绑定
            handler() {
                this._style.height = this.realtimeData.height + 'px'  // componentsMixin 中对 _style 进行了检查更新style 绑定至矩形框
                this.wrapperStyle.height = this.realtimeData.height +'px'
                this.settings.height = this.realtimeData.height
            }
        },
        'realtimeData.width': {  // 宽度绑定
            handler() {
                //console.log("宽度发生改变",this.realtimeData.width,this.style)
                this._style.width = this.realtimeData.width + 'px'
                this.wrapperStyle.width = this.realtimeData.width +'px'  // 编辑框
                this.settings.width = this.realtimeData.width
            }
        },
    }

}


